import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const BalanceTrend = ({ averageMonthlyBalances = [], onMonthClick }) => {
  if (!averageMonthlyBalances || averageMonthlyBalances.length === 0) {
    return <div>No data available for balance trends.</div>;
  }

  // Prepare data for the chart
  const chartData = averageMonthlyBalances.map((entry) => ({
    month: new Date(entry.start_date).toLocaleString("default", {
      month: "short",
      year: "numeric",
    }),
    balance: entry.amount || 0,
    start_date: entry.start_date, // Include the start date for filtering
    end_date: entry.end_date,
  }));

  // Handle click on a chart point
  const handlePointClick = (data) => {
    if (data && onMonthClick) {
      onMonthClick(data.start_date, data.end_date);
    }
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        onClick={(e) => {
          if (e && e.activePayload) {
            handlePointClick(e.activePayload[0].payload);
          }
        }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
          interval={0}
          label={{
            value: "Month",
            position: "insideBottom",
            offset: -5,
            fontSize: 14,
          }}
        />
        <YAxis
          tickFormatter={(value) => `$${(value / 1000).toFixed(1)}k`}
          domain={["auto", "auto"]}
          label={{
            value: "Average Balance ($)",
            angle: -90,
            position: "insideLeft",
            fontSize: 14,
          }}
          tick={{ fontSize: 12 }}
        />
        <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
        <Line
          type="monotone"
          dataKey="balance"
          stroke="#82ca9d"
          strokeWidth={2}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default BalanceTrend;

